import { render, staticRenderFns } from "./LandingPage.vue?vue&type=template&id=604f24ac&scoped=true&"
import script from "./LandingPage.vue?vue&type=script&lang=ts&"
export * from "./LandingPage.vue?vue&type=script&lang=ts&"
import style0 from "./LandingPage.vue?vue&type=style&index=0&id=604f24ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604f24ac",
  null
  
)

export default component.exports